import { useState } from "react";
import {
  Container,
  CssBaseline,
  Box,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../hooks/redux-hooks";
import { sendResetPasswordEmail, sendResetPasswordEmailToDriver } from "../slices/authSlice";
import {
  showNotification,
  NotificationType,
} from "../slices/notificationSlice";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState("");

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get("type") || "customer";

  const handleSubmit = async () => {
    if (!email) {
      dispatch(
        showNotification({
          message: t("pleaseInputEmail"),
          type: NotificationType.Error,
        })
      );
      return;
    }

    try {
      //const result = await dispatch(sendResetPasswordEmail(email)).unwrap();
      let result;
      if (type === "driver") {
        result = await dispatch(sendResetPasswordEmailToDriver(email)).unwrap();
      } else {
        result = await dispatch(sendResetPasswordEmail(email)).unwrap();
      }
      // 只有在成功时才显示成功消息
      if (result) {
        dispatch(
          showNotification({
            message: t("resetPasswordEmailSent"),
            type: NotificationType.Success,
          })
        );
      }
    } catch (error: any) {
      dispatch(
        showNotification({
          message: error?.message || t("resetPasswordEmailFailed"),
          type: NotificationType.Error,
        })
      );
    }
  };

  return (
    <Container maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          mt: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3 }}>
          {t("resetPassword")}
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, textAlign: "center" }}>
          {t("resetPasswordDesc")}
        </Typography>
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label={t("emailAddress")}
          name="email"
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3 }}
          onClick={handleSubmit}
        >
          {t("sendResetEmail")}
        </Button>
      </Box>
    </Container>
  );
};

export default ForgotPassword;